import { ClientComponentRunner } from '../../_common/client/client-component-runner';
import { CustomerReviewItemComponent } from './customer-review-item.component';
import { CustomerReviewItemFactory } from './customer-review-item.factory';

const runner = new ClientComponentRunner(CustomerReviewItemFactory, CustomerReviewItemComponent.name);
runner.runClientJs();
